export default class MonitoringRulesEdit {

  constructor() {}

  render() {

    $('.rule-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let el = $(this);
      let hiddenId = $(this).data('hidden-criteria');

      // Hide and disable
      $('.criteria-fields').addClass('d-none');
      $('.criteria-fields').find('input, select').attr('disabled', true);

      // Unhide and enable selected
      $('#' + hiddenId).removeClass('d-none');
      $('#' + hiddenId).find('input, select').attr('disabled', false);

      // Reset other rule search options
      $('.rule-search').not(el).val('');

    });

  }

}
